<div edsGrid>
  <div *ngIf="!isSiteIntl">
    <div edsSpacing="md"></div>
    <eds-section-header
      [title]="
        'products.distribution-historical-distributions-per-share'
          | translate: fundId
      "
      [level]="6"
    ></eds-section-header>
  </div>

  <div edsSubGrid="layout-6" edsSpacing="md">
    <div>
      <div edsSpacing="md"></div>
      <button edsButton="secondary" (click)="onDownloadButtonClicked()">
        <eds-icon
          type="download"
          size="small"
          edsPadding
          edsPaddingRight="xs"
        ></eds-icon>
        {{
          "products.distribution-download-historical-distributions" | translate
        }}
        ({{ "products.xls-file-extension" | translate }})
      </button>
    </div>
    <div>
      <div edsSpacing="md"></div>
      <eds-dropdown
        ariaLabel="Dropdown"
        [dropdownId]="id"
        name="distribution-year-select"
        label="{{ 'products.year' | translate }}"
        [items]="yearOptionList"
        [titleText]="getTitleText(yearOptionSelected)"
        [selectedText]="yearOptionSelected"
        (dropdownChange)="onDistributionYearChanged($event)"
      ></eds-dropdown>
    </div>
  </div>

  <div #scroll></div>

  <div *ngIf="isSiteIntl" edsRow edsSpacing="md">
    <div edsCol class="table-wrapper">
      <table
        class="table"
        #tableResponsive
        [style.display]="(isHandheld$ | async) ? 'none' : ''"
      >
        <ng-container *ngIf="showCanadaDistForEtfMfMmf; else non_canada">
          <ng-container *ngIf="productType === 'ETFs'">
            <thead class="table__thead">
              <tr class="table__tr">
                <th class="table__th">
                  {{ "pds.MARKET_CURRENCY" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "products.dist-ex-dist-date" | translate }}
                  <!-- {{ "pds.EX_DIST_DATE" | translate: fundId }} -->
                  <!-- Check PDS "Ex-distribution date" Label -->
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "products.dist-cash-dist-per-unit" | translate }}
                  <!-- {{ "pds.CASH_DIST_PER_UNIT" | translate: fundId }} -->
                </th>
                <!-- Check PDS "Cash Distribution Per Unit" Label -->
                <th class="table__th">
                  {{ "products.dist-rein-dist-per-unit" | translate }}
                  <!-- {{ "pds.REIN_DIST_PER_UNIT" | translate: fundId }} -->
                </th>
                <!-- Check PDS "Reinvested Distribution Per Unit" Label -->
                <th class="table__th">
                  {{ "products.dist-total-dist-per-unit" | translate }}
                  <!-- {{ "pds.TOTAL_DIST_PER_UNIT" | translate: fundId }} -->
                </th>
                <!-- Check PDS "Total Distributions per Unit" Label -->
              </tr>
            </thead>

            <tbody class="table__body">
              <tr
                class="table__tr"
                *ngFor="let distributionHistory of historicalList"
              >
                <td class="table__td">
                  {{ distributionHistory.currencyCode }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionRecordDate }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionExDividendDate }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionExPayableDate }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionAmount }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.reInvestmentAmount }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.totalDistributionAmountMonthly }}
                </td>
              </tr>
            </tbody>
          </ng-container>

          <ng-container
            *ngIf="
              productType === 'Mutual Funds' ||
              productType === 'Money Market Funds'
            "
          >
            <thead class="table__thead">
              <tr class="table__tr">
                <th class="table__th">
                  {{ "pds.SHARE_CLASS_CURRENCY" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
                </th>
                <th class="table__th">
                  {{ "products.dist-dist-price" | translate }}
                </th>
                <!-- Check PDS "Distribution Price" Label -->
                <th class="table__th">
                  {{ "products.dist-inv-income" | translate }}
                </th>
                <!-- Check PDS "Investment Income" Label -->
                <th *ngIf="isSiteIntl" class="table__th">
                  {{ "products.dist-return-of-cap" | translate }}
                </th>
                <!-- Check PDS "Return of Capital" Label -->
                <th class="table__th">
                  {{ "products.dist-capgains" | translate }}
                </th>
                <!-- Check PDS "Capital Gains" Label -->
                <th class="table__th">
                  {{ "products.dist-total-dist-per-unit" | translate }}
                </th>
                <!-- Check PDS "Total Distributions per Unit" Label -->
              </tr>
            </thead>

            <tbody class="table__body">
              <tr
                class="table__tr"
                *ngFor="let distributionHistory of historicalList"
              >
                <td class="table__td">
                  {{ distributionHistory.currencyCode }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionRecordDate }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionExDividendDate }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.exDividendNavValue }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.incomeDistributionAmount }}
                </td>
                <td *ngIf="isSiteIntl" class="table__td">
                  {{ distributionHistory.returnOfCapitalAmount }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.longTermCapitalGain }}
                </td>
                <td class="table__td">
                  {{ distributionHistory.totalDistributionAmountMonthly }}
                </td>
              </tr>
            </tbody>
          </ng-container>
        </ng-container>
        <ng-template #non_canada>
          <thead class="table__thead">
            <tr class="table__tr">
              <th class="table__th">
                {{ "pds.SHARE_CLASS_CURRENCY" | translate: fundId }}
              </th>
              <th class="table__th">
                {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
              </th>
              <th class="table__th" *ngIf="!hideExDistDate">
                {{ "pds.INCM_DIST_EX_DIV_DATE" | translate: fundId }}
              </th>
              <th class="table__th">
                {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
              </th>
              <th class="table__th">
                {{ "pds.NAV_VALUE" | translate: fundId }}
              </th>
              <th class="table__th">
                {{ "pds.INCM_DIST_AMT" | translate: fundId }}
              </th>
              <th class="table__th" *ngIf="latestConfig.isSgHk">
                {{ "pds.INCM_DIST_INCOME" | translate: fundId }}
                <eds-footnote
                  placement="distributable-income-column-header"
                ></eds-footnote>
                <eds-icon
                  class="print-hidden"
                  *ngIf="
                    tooltips['products.distributable-income-column-header']
                  "
                  edsTooltip
                  edsPadding
                  tooltipTheme="dark"
                  type="info"
                  size="small"
                  [analyticsName]="'pds.INCM_DIST_INCOME' | translate: fundId"
                  [tooltipContent]="
                    tooltips['products.distributable-income-column-header']
                  "
                ></eds-icon>
              </th>
              <th class="table__th" *ngIf="latestConfig.isSgHk">
                {{ "pds.INCM_DIV_CAPITAL" | translate: fundId }}
                <eds-footnote
                  placement="dividend-income-column-header"
                ></eds-footnote>
                <eds-icon
                  class="print-hidden"
                  *ngIf="tooltips['products.dividend-income-column-header']"
                  edsTooltip
                  edsPadding
                  tooltipTheme="dark"
                  type="info"
                  size="small"
                  [analyticsName]="'pds.INCM_DIV_CAPITAL' | translate: fundId"
                  [tooltipContent]="
                    tooltips['products.dividend-income-column-header']
                  "
                ></eds-icon>
              </th>
            </tr>
          </thead>

          <tbody class="table__body">
            <tr
              class="table__tr"
              *ngFor="let distributionHistory of historicalList"
            >
              <td class="table__td">{{ distributionHistory.currencyCode }}</td>
              <td class="table__td">
                {{ distributionHistory.incomeDistributionRecordDate }}
              </td>
              <td class="table__td" *ngIf="!hideExDistDate">
                {{ distributionHistory.incomeDistributionExDividendDate }}
              </td>
              <td class="table__td">
                {{ distributionHistory.incomeDistributionExPayableDate }}
              </td>
              <td class="table__td">
                {{ distributionHistory.exDividendNavValue }}
              </td>
              <td class="table__td">
                {{
                  distributionHistory?.totalDistributionAmountMonthly
                    ? distributionHistory.totalDistributionAmountMonthly
                    : distributionHistory.incomeDistributionAmount
                }}
              </td>
              <td class="table__td" *ngIf="latestConfig.isSgHk">
                {{ distributionHistory.divDistributionIncome }}
              </td>
              <td class="table__td" *ngIf="latestConfig.isSgHk">
                {{ distributionHistory.dividendCapital }}
              </td>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
  </div>

  <div edsRow *ngIf="!isSiteIntl">
    <div edsCol class="table-wrapper">
      <table
        class="table"
        #tableResponsive
        [style.display]="(isHandheld$ | async) ? 'none' : ''"
      >
        <thead class="table__thead">
          <tr class="table__tr">
            <th class="table__th">
              {{ "pds.INCM_DIST_RECORD_DATE" | translate: fundId }}
            </th>
            <th class="table__th">
              {{ "pds.INCM_DIST_EX_DIV_DATE" | translate: fundId }}
            </th>
            <ng-container *ngIf="productType !== productConfigurationType.CEF">
              <th class="table__th">
                {{ "pds.REINVESTMENT_DATE" | translate: fundId }}
              </th>
            </ng-container>
            <th class="table__th">
              {{ "pds.INCM_DIST_PAYABLE_DATE" | translate: fundId }}
            </th>
            <ng-container *ngIf="productType !== productConfigurationType.CEF">
              <th class="table__th">
                {{ "pds.REINVESTMENT_AMT" | translate: fundId }}
              </th>
            </ng-container>
            <ng-container
              *ngIf="
                productType !== productConfigurationType.TOF &&
                productType !== productConfigurationType.CEF
              "
            >
              <th class="table__th">
                {{ "pds.CAPGAIN_AMT_LONG_TERM" | translate: fundId }}
              </th>
              <th class="table__th">
                {{ "pds.CAPGAIN_AMT_SHRT_TERM" | translate: fundId }}
              </th>
            </ng-container>
            <ng-container *ngIf="productType !== productConfigurationType.CEF">
              <th class="table__th">
                {{ "pds.INCOME_AMOUNT" | translate: fundId }}
              </th>
            </ng-container>
            <ng-container
              *ngIf="isSiteIntl && productType !== productConfigurationType.TOF"
            >
              <th class="table__th">
                {{ "pds.TAXABLE_EXEMPT_INCOME" | translate: fundId }}
              </th>
            </ng-container>
            <th class="table__th" *ngIf="isSiteIntl">
              {{ "pds.RETURN_OF_CAPITAL_AMT" | translate: fundId }}
            </th>
            <th class="table__th">
              {{ "pds.TOTAL_DISTRIBUTION_PER_SHARE" | translate: fundId }}
            </th>
          </tr>
        </thead>

        <tbody class="table__body">
          <tr
            class="table__tr"
            *ngFor="let distributionHistory of historicalList"
          >
            <td class="table__td" *ngIf="distributionHistory.showIncomeFlag">
              <!-- Intentionally evaluated above condition as a method, to easily modify the logic, if needed.
                Also, it is consistent to boolean flag used in distribution latest component. -->
              {{ distributionHistory.incomeDistributionRecordDate }}
            </td>
            <td class="table__td" *ngIf="!distributionHistory.showIncomeFlag">
              {{ distributionHistory.capitalGainRecordDate }}
            </td>
            <td class="table__td" *ngIf="distributionHistory.showIncomeFlag">
              {{ distributionHistory.incomeDistributionExDividendDate }}
            </td>
            <td class="table__td" *ngIf="!distributionHistory.showIncomeFlag">
              {{ distributionHistory.capitalGainExDividendDate }}
            </td>
            <ng-container *ngIf="productType !== productConfigurationType.CEF">
              <td class="table__td" *ngIf="distributionHistory.showIncomeFlag">
                {{ distributionHistory.reInvestmentDate }}
              </td>
              <td class="table__td" *ngIf="!distributionHistory.showIncomeFlag">
                {{ distributionHistory.capitalGainReInvestmentDate }}
              </td>
            </ng-container>

            <td class="table__td" *ngIf="distributionHistory.showIncomeFlag">
              {{ distributionHistory.incomeDistributionExPayableDate }}
            </td>
            <td class="table__td" *ngIf="!distributionHistory.showIncomeFlag">
              {{ distributionHistory.capitalGainPayableDate }}
            </td>
            <ng-container *ngIf="productType !== productConfigurationType.CEF">
              <td class="table__td">
                {{ distributionHistory.reInvestmentAmount }}
              </td>
            </ng-container>
            <ng-container
              *ngIf="
                productType !== productConfigurationType.TOF &&
                productType !== productConfigurationType.CEF
              "
            >
              <td class="table__td">
                {{ distributionHistory.longTermCapitalGain }}
              </td>
              <td class="table__td">
                {{ distributionHistory.shortTermCapitalGain }}
              </td>
            </ng-container>
            <ng-container *ngIf="productType !== productConfigurationType.CEF">
              <td class="table__td">
                {{ distributionHistory.incomeDistributionAmount }}
              </td>
            </ng-container>
            <ng-container
              *ngIf="isSiteIntl && productType !== productConfigurationType.TOF"
            >
              <td class="table__td">
                {{ distributionHistory.taxExemptIncomeAmount }}
              </td>
            </ng-container>
            <td class="table__td" *ngIf="isSiteIntl">
              {{ distributionHistory.returnOfCapitalAmount }}
            </td>
            <td class="table__td">
              {{ distributionHistory.totalDistributionAmountMonthly }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div edsRow *ngFor="let card of cards">
    <div edsCol *ngIf="isHandheld$ | async">
      <eds-panel
        edsSpacing="sm"
        [hasBorders]="true"
        [hasBorderRadius]="false"
        [hasPadding]="true"
        [theme]="'white'"
      >
        <eds-info-item *ngFor="let item of card" [info]="item" edsSpacing="sm">
        </eds-info-item>
      </eds-panel>
    </div>
  </div>

  <div edsRow *ngIf="totalPages > 0">
    <div edsCol>
      <eds-pagination
        [pages]="totalPages"
        [pageTitle]="pageTitle"
        (pageChanged)="onPageChanged($event)"
        [prevPageText]="'products.previous' | translate"
        [nextPageText]="'products.next' | translate"
        [ariaLabelGoToPage]="'products.ariaLabelGoToPage' | translate"
      ></eds-pagination>
    </div>
  </div>
</div>
